export default "__VITE_ASSET__B6UwKePt__"